import { createApp } from '@o-din/app';

import Maintenance from '@o-din-maintenance/src/o-din-maintenance';
import Ppr from '@o-din-ppr/src/o-din-ppr';
import Rounds from '@o-din-rounds/src/o-din-rounds';
import Report from '@o-din-report/src/o-din-report';

createApp('#app', [Maintenance, Rounds, Report, Ppr]);
